import { Modal } from 'almanac-ui/Modal'
import Styles from '../TemplatesV2.module.scss'
import { Search } from './Search'
import { FilterKey, IFilters } from '../Types'
import { Filters } from './Filters'

interface Props {
  filters: IFilters
  onFilterChange: (f: IFilters) => any
  isFormatEditable: boolean
  onClose?: () => void
  disabledFilters?: FilterKey[]
}

export const MobileHeader = ({ filters, onFilterChange, onClose, disabledFilters }: Props) => {
  return (
    <>
      <Modal.Header onClose={onClose} title="Choose from All Templates" />
      <div className={Styles.mobileSearchAndFilters}>
        <div className={Styles.headerSearchContainer}>
          <Search
            query={filters.query}
            onChange={(newQuery) => onFilterChange({ ...filters, query: newQuery })}
            useCompactUI
          />
        </div>
        <Filters
          value={filters}
          onChange={onFilterChange}
          hiddenFilters={['format']}
          disabledFilters={disabledFilters}
          useCompactUI
        />
      </div>
    </>
  )
}
